import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useStoryStyleCardContext } from "~/components/story-style/story-style-card/contexts";
import type { imageStoryStyleCardImageArticle$key } from "~/queries/__generated__/imageStoryStyleCardImageArticle.graphql";

import { Container, OverlayBottom, OverlayTop, StyledImage } from "./styles";

export type Props = {
  reference: imageStoryStyleCardImageArticle$key;
};

const animationTypeList = ["zoomIn", "penLeft", "still", "zoomIn"];

export const StoryStyleCardImage: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const { articleCardIndex } = useStoryStyleCardContext();
  const articleImages = useFragment(
    graphql`
      fragment imageStoryStyleCardImageArticle on Article {
        images(filter: { type: { exclude: null } }) {
          alt
          isSlideshow
          url: style(filter: { style: "portrait" }) {
            url
          }
        }
      }
    `,
    reference_,
  );

  const filteredImage = (articleImages?.images ?? []).find(image => image?.isSlideshow);
  /** aspect ratio reference link:  https://staging-scmp-d8.product-web.dev-2.scmp.tech/admin/config/media/image-styles/manage/portrait */
  const $aspectRatio = "2/3";
  const imageAlt = filteredImage?.alt ?? "";
  const imageUrl = filteredImage?.url?.url ?? "";

  return (
    <Container>
      <OverlayTop />
      <StyledImage
        $animationType={animationTypeList[articleCardIndex % 4]}
        $aspectRatio={$aspectRatio}
        alt={imageAlt}
        lazyload={false}
        src={imageUrl}
      />
      <OverlayBottom />
    </Container>
  );
};

StoryStyleCardImage.displayName = "StoryStyleCardImage";
